module.exports = __webpack_public_path__ + "media/images/bg-bitcoin-f9aeae546f0e4c287df2902a1af5f9a0.jpg";